import ArrowAngleDownIcon from "Components/Icons/ArrowAngleDownIcon";
import ArrowAngleUpIcon from "Components/Icons/ArrowAngleUpIcon";
import React from "react";
import { Dropdown } from "react-bootstrap";

interface CustomToggleProps extends React.ComponentPropsWithoutRef<typeof Dropdown.Toggle> {
    readonly isDropdownOpen: boolean;
}

const CustomToggle = React.forwardRef<HTMLButtonElement, CustomToggleProps>(
    ({ children, onClick, isDropdownOpen }, ref) => (
        <button
            type="button"
            className="custom-dropdown-toggle"
            ref={ref}
            onClick={(e) => {
                onClick?.(e);
            }}
        >
            <span className="toggle-text-dropdown">{children}</span>
            {isDropdownOpen ? <ArrowAngleUpIcon /> : <ArrowAngleDownIcon />}
        </button>
    ),
);

CustomToggle.displayName = "CustomToggle";

export default CustomToggle;